// Ameersha N : 27-11-2023 : BT-116461 Breeze - Addendum and Notices --Start
import { LOCATIONS } from "../../utils/global_variables";
import { ADDENDUMANDNOTICES } from "../actionTypes";

const initialState = {
    arrAddEndumNoticedReport: [],
    anddEndumNoticesInfo: [],
    isAccepted: false,
    isOpen: false,
    lastLocation: LOCATIONS.WATCHLIST
};

// Ameersha N : 17-11-2023 : BT-116461 Breeze - Addendum and Notices --Start
const addEndumReducer = (state = initialState, actions) => {
    switch (actions.type) {
        case ADDENDUMANDNOTICES?.UPDATE_ADD_NOT_LAST_LOCATION:
            return {
                ...state,
                lastLocation: actions?.payload
            };
        case ADDENDUMANDNOTICES?.UPDATE_ADD_ENDUM_NOTICES_REPORT:
            return {
                ...state,
                arrAddEndumNoticedReport: actions?.payload
            };
        case ADDENDUMANDNOTICES?.UPDATE_IS_ADD_ENDUM_MODAL_OPEN: {
            return {
                ...state,
                isOpen: actions?.payload
            };
        }

        case ADDENDUMANDNOTICES?.UPDATE_IS_ADD_END_DUM_ACCEPTED_OR_REJECTED: {
            return {
                ...state,
                isAccepted: actions?.payload
            };
        }
        case (ADDENDUMANDNOTICES.GET_ADD_ENDUMAND_NOTICES_SUCCESS): {
            return {
                ...state,
                anddEndumNoticesInfo: actions.payload
            };
        }
        case (ADDENDUMANDNOTICES.GET_ADD_ENDUMAND_NOTICES_FAILURE): {
            return {
                ...state,
                anddEndumNoticesInfo: actions.payload
            };
        }
        default:
            return state;
    }

};
// Ameersha N : 17-11-2023 : BT-116461 Breeze - Addendum and Notices --End

export default addEndumReducer;
// Ameersha N : 27-11-2023 : BT-116461 Breeze - Addendum and Notices --End